import React, { createContext, useContext } from 'react'
import { useProximityState } from '../hooks/useProximityState'
import type { ProximityState } from '../types/LiveKitVideoDisplay.types'

const LiveKitProximityContext = createContext<ProximityState | null>(null)

/**
 * Single mount of useProximityState for the whole LiveKit video UI subtree.
 * Avoids N× 50ms proximity timers and duplicate React state.
 */
export const LiveKitProximityProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const proximityState = useProximityState()
  return (
    <LiveKitProximityContext.Provider value={proximityState}>
      {children}
    </LiveKitProximityContext.Provider>
  )
}

export function useLiveKitProximity(): ProximityState {
  const ctx = useContext(LiveKitProximityContext)
  if (!ctx) {
    throw new Error('useLiveKitProximity must be used within LiveKitProximityProvider')
  }
  return ctx
}

/** For hooks that may run outside the provider (e.g. manual safety control). */
export function useLiveKitProximityOptional(): ProximityState | null {
  return useContext(LiveKitProximityContext)
}
